import React, { useState, useEffect } from "react";
import '../../styles/MBAFinanceLanding.css';
import { postStudentEnquiry, getGalleryImages, getPlacedStudents } from '../../services/getAllApi';
import { classRoom1, classRoom2, classRoom3, i0, i1, i2, i3 } from '../../assets/index';

const MBAFinanceLanding = () => {

  const backgrounds = [classRoom1, classRoom2, classRoom3];
  const [currentBackground, setCurrentBackground] = useState(0);
  const [fadeOut, setFadeOut] = useState(false);
  const [companies, setCompanies] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [scrollPosition, setScrollPosition] = useState(0);
  const [rightScrollPosition, setRightScrollPosition] = useState(0);
  const [placedStudentData, setPlacedStudentData] = useState([])


  const [formData, setFormData] = useState({
    first_name: '',
    last_name: '',
    email_address: '',
    contact_number: '',
    course_interested: '',
    city: '',
    agree: false,
    more_info: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [successMessage, setSuccessMessage] = useState('');

  const fetchCompanyImages = async () => {
    try {
      const response = await getGalleryImages("RecruiterCompanies");
      setCompanies(Array.isArray(response.data.images) ? response.data.images : []);
    } catch (error) {
      console.error("Error fetching images:", error);
    }
  };

  const CallplacedStudentData = async () => {
    getPlacedStudents()
      .then((res) => {
        if (res.status === 200) {
          setPlacedStudentData(res.data.slice().reverse())
        }

      })
  }

  useEffect(() => {
    fetchCompanyImages()
    CallplacedStudentData()
    const scrollSpeed = 0.5;
    const maxScroll = 50 * 100;

    const animate = () => {
      setScrollPosition(prev => {
        const newPosition = prev + scrollSpeed;
        return newPosition >= maxScroll ? 0 : newPosition;
      });
      setRightScrollPosition(prev => {
        const newPosition = prev - scrollSpeed;
        return newPosition <= -maxScroll ? 0 : newPosition;
      });
      requestAnimationFrame(animate);
    };

    const animation = requestAnimationFrame(animate);
    return () => cancelAnimationFrame(animation);

  }, []);


  useEffect(() => {
    const interval = setInterval(() => {
      setFadeOut(true);
      setTimeout(() => {
        setCurrentBackground((prevIndex) => (prevIndex + 1) % backgrounds.length);
        setFadeOut(false);
      }, 250);
    }, 5000);

    return () => clearInterval(interval);
  }, [backgrounds.length]);

  const toggleModal = () => setIsModalOpen(!isModalOpen);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });


    if (!formData.first_name || !formData.last_name || !formData.email_address ||
      !formData.contact_number || !formData.course_interested || !formData.city ||
      !formData.agree) {
      setError('Please fill in all fields and agree to the terms.');
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const response = await postStudentEnquiry(formData);
      if (response.status === 201 || response.status === 200) {
        setSuccessMessage('Your request has been successfully submitted!');
        setFormData({
          first_name: '',
          last_name: '',
          email_address: '',
          contact_number: '',
          course_interested: '',
          city: '',
          more_info: '',
          agree: false
        });
      } else {
        setError(JSON.stringify(response.response.data.message));
      }
    } catch (error) {
      setError('An error occurred while submitting the form.');
    } finally {
      setLoading(false);
    }
  };
  
  const handleDownload = () => {
    const link = document.createElement("a");
    link.href = "/FBS Guaranteed Job MBA 2025.pdf"; // Ensure it's inside 'public' folder
    link.download = "FBS-Brochure.pdf"; // Sets the download filename
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const cards = Array(12).fill(null);
  const images = [i0, i1, i2, i3];

  return (
    <div className="relative min-h-screen text-white">

      <div
        className={`absolute inset-0 bg-cover bg-center transition-opacity duration-500 ${fadeOut ? "opacity-0" : "opacity-100"
          }`}
        style={{
          backgroundImage: `url(${backgrounds[currentBackground]})`,
        }}
      />


      <div className="absolute top-0 left-0 h-full w-full bg-gradient-to-r from-blue-950 via-blue-900 to-transparent [background-position:70%]" />


      <div className="container mx-auto flex flex-col lg:flex-row items-start justify-between gap-8 py-12  relative z-10">

        <div className="w-full xl:w-[100%]  sm:ml-0">
          <h1 className="text-4xl lg:text-4xl font-bold mb-4">Welcome to FINXL Business School (FBS)</h1>
          <h4 className="text-xl text-gray-200 mb-2">On Job Practical</h4>
          <h2 className="text-3xl lg:text-6xl font-bold text-yellow-400 mb-6">
            MBA in Finance
          </h2>
          <p className="inline-block bg-yellow-200 text-yellow-900 px-8 py-2 rounded-md font-medium mb-4">
            <span className="font-bold">
              Kickstart your career with our special designed MBA courses
            </span>
          </p>
          <p className="text-gray-200 leading-7 mb-12">
            Designed for students and working professionals that helps develop
            world-class Management Business Administration in Finance acumen
            that attracts global opportunities.
          </p>


          <div className="w-full overflow-hidden">
            {/* First Scrolling Section (Left to Right) */}
            <div className="relative h-32 mb-4 overflow-hidden">
              <div className="flex absolute animate-scroll-left">
                {[...placedStudentData, ...placedStudentData].map((student, index) => {
                  const imageIndex = index % images.length;
                  return (
                    <div
                      key={`left-${index}`}
                      className="flex-shrink-0 w-64 h-[8rem] bg-white rounded-lg shadow-lg p-4 mr-4"
                    >
                      <div className="flex items-inherit mt-[-1px] justify-between">
                        <img
                          src={`${"https://console.fbsedu.in/storage/app/"}/public/${student.student_photo.slice(7)}`}
                          className="w-24 h-24 rounded-full object-contain"
                          alt={`Profile ${imageIndex + 1}`}
                        />
                        <div className="flex flex-col">
                          <p className="text-black text-md w-[180px] items-start">{student.student_name}</p>
                          <img
                            src={`${"https://console.fbsedu.in/storage/app/"}/public/${student.company_logo?.length > 0 ? student.company_logo?.slice(7) : ''}`}
                            className="w-24 h-20 object-contain items-end ml-[20px]"
                            alt="Company Logo"
                          />
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>

            {/* Second Scrolling Section (Right to Left) */}
            <div className="relative h-32 overflow-hidden">
              <div className="flex absolute animate-scroll-right">
                {[...companies, ...companies].map((image, index) => (
                  <div
                    key={`right-${index}`}
                    className="flex-shrink-0 w-64 bg-white rounded-lg shadow-lg p-4 mr-4"
                  >
                    <div className="flex items-center justify-center">
                      <img
                        src={`${"https://console.fbsedu.in/storage/app/"}/public/${image.image_path.slice(7)}`}
                        className="w-32 h-16 object-contain"
                        alt="Company Logo"
                      />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>


        </div>

        <div className="w-full xl:w-[50%] bg-white/60 text-black shadow-lg rounded-lg p-8 relative lg:top-[0rem]" id="homePageForm">
          <h3 className="text-2xl font-bold mb-6 text-orange-500">Enter Details</h3>
          <form onSubmit={handleSubmit} >
            <div className="grid gap-[0.6rem] relative bottom-[1rem]">
              <div className="flex gap-4  ">
                <input
                  type="text"
                  name="first_name"
                  value={formData.first_name}
                  onChange={handleChange}
                  placeholder="First Name"
                  className="w-full p-[0.5rem] border border-gray-300 rounded-md focus:outline-none"
                />
                <input
                  type="text"
                  name="last_name"
                  value={formData.last_name}
                  onChange={handleChange}
                  placeholder="Last Name"
                  className="w-full p-[0.5rem] border border-gray-300 rounded-md focus:outline-none"
                />
              </div>
              <input
                style={{ width: '100%', padding: '0.5rem' }}
                type="tel"
                name="contact_number"
                value={formData.contact_number}
                onChange={handleChange}
                placeholder="Phone No. +91"
                className="w-full p-[0.5rem] border border-gray-300 rounded-md focus:outline-none"
              />
              <input
                type="email_address"
                name="email_address"
                value={formData.email_address}
                onChange={handleChange}
                placeholder="Email"
                className="w-full p-[0.5rem] border border-gray-300 rounded-md focus:outline-none"
              />
              <select
                name="course_interested"
                value={formData.course_interested}
                onChange={handleChange}
                className="w-full p-[0.5rem] border border-gray-300 rounded-md focus:outline-none"
              >
                <option value="" disabled>Course Interested</option>
                <option value="MBA in Finance">MBA in Finance</option>
              </select>

              <input
                type="text"
                name="city"
                value={formData.city}
                onChange={handleChange}
                placeholder="City"
                className="w-full p-[0.5rem] border border-gray-300 rounded-md focus:outline-none"
              />
              <input
                type="text"
                name="more_info"
                value={formData.more_info}
                onChange={handleChange}
                placeholder="More Info"
                className="w-full p-[0.5rem] border border-gray-300 rounded-md focus:outline-none"
              />
              <div className="flex flex-col items-start gap-4">
                <p className="text-left text-gray-600 text-[0.6rem]">
                  By clicking the button below, you agree to receive communications via email/Call/WhatsApp/SMS from FBS-FINXL Business School.
                </p>
                <div className="flex items-center gap-2">
                  <input
                    type="checkbox"
                    id="agree"
                    name="agree"
                    checked={formData.agree}
                    onChange={handleChange}
                    className="w-4 h-4 border-2 border-orange-500 rounded bg-white checked:bg-orange-500 checked:border-orange-600 focus:outline-none appearance-none relative before:absolute before:content-['✔'] before:text-white before:text-xs before:left-1/2 before:top-1/2 before:-translate-x-1/2 before:-translate-y-1/2 before:hidden checked:before:block"
                  />

                  <label htmlFor="agree" className="text-[0.7rem] text-gray-600 text-left">
                    I have read and agree to FBS's <a href="/terms" class="text-orange-500 underline">terms & conditions</a>.
                  </label>
                </div>
              </div>
              {error && <p className="text-red-500">{error}</p>}
              {successMessage && <p className="text-green-500">{successMessage}</p>}


              <div className="downloadB">
                <div class="wrapper">
                  <a onClick={handleDownload} class="c-btn">
                    <span class="c-btn__label">BROCHURE
                      <svg width="18" height="18" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M7.50005 1.04999C7.74858 1.04999 7.95005 1.25146 7.95005 1.49999V8.41359L10.1819 6.18179C10.3576 6.00605 10.6425 6.00605 10.8182 6.18179C10.994 6.35753 10.994 6.64245 10.8182 6.81819L7.81825 9.81819C7.64251 9.99392 7.35759 9.99392 7.18185 9.81819L4.18185 6.81819C4.00611 6.64245 4.00611 6.35753 4.18185 6.18179C4.35759 6.00605 4.64251 6.00605 4.81825 6.18179L7.05005 8.41359V1.49999C7.05005 1.25146 7.25152 1.04999 7.50005 1.04999ZM2.5 10C2.77614 10 3 10.2239 3 10.5V12C3 12.5539 3.44565 13 3.99635 13H11.0012C11.5529 13 12 12.5528 12 12V10.5C12 10.2239 12.2239 10 12.5 10C12.7761 10 13 10.2239 13 10.5V12C13 13.1041 12.1062 14 11.0012 14H3.99635C2.89019 14 2 13.103 2 12V10.5C2 10.2239 2.22386 10 2.5 10Z" fill="currentColor" fill-rule="evenodd" clip-rule="evenodd">
                        </path>
                      </svg>
                    </span>
                  </a>
                </div>
              </div>
              <div>
                <button
                  type="submit"
                  className="w-full bg-orange-500 hover:bg-orange-600 text-white font-bold py-3 rounded-md"
                  disabled={loading}
                >
                  {loading ? 'Submitting...' : 'Submit'}
                </button>
              </div>
            </div>
          </form>
          {/* <button
            onClick={toggleModal}
            className="fixed top-[50%] right-5 bg-orange-500 text-white py-2 px-6 rounded text-xl shadow-lg hover:bg-orange-600 origin-right cursor-pointer z-50"
            style={{ rotate: '90deg' }}>
            ENQUIRY
          </button> */}

        </div>
      </div>

    </div>
  );
};

export default MBAFinanceLanding;
